import React from "react";
import { intl } from "../i18n/TypedIntl";
import classNames from "classnames";
import styles from "./notificationComponent.css";
import { IChatNotification } from "../models/mst/ui/ChatNotification";
import { NotificationLevel } from "../models/mst/ui/ChatNotificationStore";

interface Props {
  notification: IChatNotification;
  onDismiss: () => void;
  dashboardStyle?: boolean;
}

export const NotificationComponent = (props: Props) => {
  const {
    notification: { onCancel, onAction, isDismissDisabled, message, level, actionText },
    onDismiss,
    dashboardStyle
  } = props;

  const onClick = (callback: () => void) => {
    callback();
    onDismiss();
  };

  const renderDismiss = () =>
    onCancel ? (
      <i className={styles.action} onClick={() => onClick(onCancel)}>
        {intl.formatMessage("popup.button.cancel")}
      </i>
    ) : (
      <i onClick={onDismiss} className="icon-close-cross" />
    );

  const renderAction = () =>
    onAction ? (
      <i className={styles.action} onClick={() => onClick(onAction)}>
        {actionText}
      </i>
    ) : undefined;

  return (
    <div
      className={classNames(styles.container, {
        [styles.dashboard]: dashboardStyle,
        [styles.error]: level === NotificationLevel.Error,
        [styles.warning]: level === NotificationLevel.Warning
      })}
    >
      <i>{message}</i>
      <div className={styles["actions-div"]}>
        {renderAction()}
        {isDismissDisabled ? undefined : renderDismiss()}
      </div>
    </div>
  );
};
